const initialState = {
  parentId: null,
  parentType: '',
  commentedId: null,
  commentedType: ''
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'DELETE_CONFIRMATION_OPEN':
      return action.deleteConfirmationSetup;
    case 'DELETE_CONFIRMATION_CLOSE':
      return initialState;
    default:
      return state;
  }
}
